/**
 * B526 (g3) — the Viator wire. Viator calls its own v2 paths against the base
 * URL a supplier registers (ours ends `/viator`), so a CLOSED table maps each
 * route onto one viator.* operation. Like OCTO_WIRE_ROUTES it is data the
 * authorizer (which op; the key read from `X-Api-Key` on these routes only),
 * the ops entry (how to translate) and the stack (which routes exist) all
 * read. Not an operation module: the registry does not collect it.
 *
 * The legacy paths (/tourlist, /booking, …) are not here yet: they also carry
 * the key in the BODY, and accepting a body credential is a class-A question
 * for Viator's kick-off (docs/ota/PARTNER-CONNECTIVITY.md § Viator).
 */
export interface ViatorWireRoute {
  readonly routeKey: string;
  readonly operation: string;
  /** The body fields kept (contracts are strict). */
  readonly fields: readonly string[];
  /** A write's idempotency source: Viator's reserve carries no id, so the request id. */
  readonly key?: "reserve";
}

export const VIATOR_WIRE_ROUTES: readonly ViatorWireRoute[] = Object.freeze([
  {
    routeKey: "POST /viator/v2/availability/check",
    operation: "viator.availability.check",
    fields: ["supplierId", "travelDate", "productOptions", "tickets", "totalTravelers"],
  },
  { routeKey: "POST /viator/v2/availability/calendar", operation: "viator.availability.calendar", fields: ["supplierId", "productOptionIds", "startDate", "endDate"] },
  {
    routeKey: "POST /viator/v2/reserve",
    operation: "viator.reserve",
    fields: ["supplierId", "productOptionId", "travelDate", "startTime", "tickets", "totalTravelers"],
    key: "reserve",
  },
]);

const BY_KEY = new Map(VIATOR_WIRE_ROUTES.map((r) => [r.routeKey, r]));

export function viatorWireRouteFor(routeKey: string): ViatorWireRoute | undefined {
  return BY_KEY.get(routeKey);
}
